import { getPolygonCentroid } from '../utils/centroid.js';

/**
 * Facet class - represents a single facet of a gem (a single quad)
 */

export class Quad {
  constructor(vertices, index) {
    this.vertices = vertices;
    this.index = index;
    this.center = getPolygonCentroid(vertices);
    this.uvs = this.vertices.map((v) => createVector(v.x, v.y)); // copy vertices to uvs
  }

  setCenter(center) {
    this.center = center;
  }

  offsetUVs(x, y) {
    this.uvs = this.uvs.map((v) => v.add(createVector(x, y)));
  }

  rotateUVs(angle) {
    this.uvs = this.uvs.map((v) => v.rotate(angle));
  }

  scaleUVs(scale) {
    this.uvs = this.uvs.map((v) => v.mult(scale));
  }

  transformAndScaleUVs(offset, rotateAngle, scale) {
    this.uvs = this.vertices.map(
      (v) =>
        p5.Vector.sub(v, this.center) // move to 0,0
          .rotate(rotateAngle) // rotate
          .add(this.center) // move back to original position
          .add(offset) // translate
          .mult(scale) // scale it
    );
  }

  getVertices() {
    return this.vertices;
  }

  getUVs() {
    return this.uvs;
  }
}
